<template>
  <CollapsePanel
    :title="$t('route_management.object_information')"
    :loading=false
    :showCount=false
    :showCollapseAction="false"
    :collapsed="true"
    :borderTop="true"
    panelName="management.information"
  >
    <div v-if="mapObject && mapObject.geoObject && mapObject.geoObject.data"
         class="object-information-block"
    >
      <h3 class="block-header">{{ $t('route_management.location_data') }}</h3>
      <ul class="block-details">
        <li v-if="mapObject.geoObject.data.properties.length" class="block-item">
          <span class="block-item-title">{{ $t('model.length') | capitalize }}:</span>
          <span class="block-item-content">
            {{ length }}
          </span>
        </li>
        <li v-if="mapObject.geoObject.data.properties.area" class="block-item">
          <span class="block-item-title">{{ $t('model.area') | capitalize }}:</span>
          <span class="block-item-content" v-html="area" />
        </li>
        <li v-if="mapObject.geoObject.data.properties.road" class="block-item">
          <span class="block-item-title">{{ $t('model.road') | capitalize }}:</span>
          <span class="block-item-content">
            {{ mapObject.geoObject.data.properties.road }}
            <span v-if="mapObject.geoObject.data.properties.house_number">
              {{ mapObject.geoObject.data.properties.house_number }}
            </span>
          </span>
        </li>
        <li v-if="mapObject.geoObject.data.properties.postcode" class="block-item">
          <span class="block-item-title">{{ $t('model.postcode') | capitalize }}:</span>
          <span class="block-item-content">{{ mapObject.geoObject.data.properties.postcode }}</span>
        </li>
        <li v-if="mapObject.geoObject.data.properties.city" class="block-item">
          <span class="block-item-title">{{ $t('model.city') | capitalize }}:</span>
          <span class="block-item-content">{{ mapObject.geoObject.data.properties.city }}</span>
        </li>
        <li v-if="mapObject.geoObject.data.properties.city_district" class="block-item">
          <span class="block-item-title">{{ $t('model.city_district') | capitalize }}:</span>
          <span class="block-item-content">
            {{ mapObject.geoObject.data.properties.city_district }}
          </span>
        </li>
        <li v-if="mapObject.geoObject.data.geometry.type === 'Point'" class="block-item">
          <span class="block-item-title">Latitude:</span>
          <span class="block-item-content">
            {{ mapObject.geoObject.data.geometry.coordinates[1] }}
          </span>
        </li>
        <li v-if="mapObject.geoObject.data.geometry.type === 'Point'" class="block-item">
          <span class="block-item-title">Longitude:</span>
          <span class="block-item-content">
            {{ mapObject.geoObject.data.geometry.coordinates[0] }}
          </span>
        </li>
      </ul>
    </div>

    <div v-if="mapObject && mapObject.attribute && mapObject.attribute.data"
         class="object-information-block"
    >
      <h3 class="block-header">{{ $t('route_management.object_data') }}</h3>
      <ul class="block-details">
        <li class="block-item" v-if="user && user.super_admin">
          <span class="block-item-title">{{ $t('model.id') | capitalize }}:</span>
          <span class="block-item-content">{{ mapObject.id }} ({{ mapObject.name }})</span>
        </li>
        <li class="block-item">
          <span class="block-item-title">{{ $t('model.created_at') | capitalize }}:</span>
          <span class="block-item-content">{{ mapObject.created_at | dateTime }}</span>
        </li>
        <li class="block-item">
          <span class="block-item-title">{{ $t('model.updated_at') | capitalize }}:</span>
          <span class="block-item-content">{{ mapObject.updated_at | dateTime }}</span>
        </li>
        <li class="block-item" v-if="mapObjectLock !== null">
          <span class="block-item-title">{{ $t('model.owner') | capitalize }}:</span>
          <span class="block-item-content"
                v-if="!selectedUser"
          >
              -
          </span>
          <span class="block-item-content" v-else-if="mapObjectLock.value === 'user'">
              {{ selectedUser.name }}
          </span>
          <span class="block-item-content" v-else-if="mapObjectLock.value === 'team'">
            {{ selectedUser.name }}
            <span v-if="selectedUser.team
                  && selectedUser.team.data
                  && selectedUser.team.data.length > 0">
              ({{ selectedUser.team.data.map(item => item.name).join(', ') }})
            </span>
          </span>
        </li>
        <li v-if="selectedType" class="block-item">
          <span class="block-item-title">{{ $tc('models.type', 1) | capitalize }}:</span>
          <span class="block-item-content">{{ selectedType.name }}</span>
        </li>
        <li v-if="selectedStatus" class="block-item">
          <span class="block-item-title">{{ $tc('models.status', 1) | capitalize }}:</span>
          <span class="block-item-content">{{ selectedStatus.name }}</span>
        </li>
        <li v-for="(attribute, index) in mapObject.attribute.data" :key="index" class="block-item">
          <span class="block-item-title">{{ attribute.name | capitalize }}:</span>
          <span class="block-item-content"><AttributeValue :attribute="attribute" /></span>
        </li>
      </ul>
    </div>

    <div v-if="hasSelections"
         class="object-information-block"
    >
      <h3 class="block-header">{{ $tc('models.selection', 0) }}</h3>
      <ul class="block-details">
        <li v-for="(selection, type) in selections" :key="type" class="block-item">
          <span class="block-item-title">{{ type }}:</span>
          <span class="block-item-content">{{ selection.join(', ') }}</span>
        </li>
        <div v-for="(parentSelection, type) in parentSelections" :key="type"
             class="parent-selections"
        >
          <h3 class="block-header">{{ parentSelection.name }}</h3>
          <ul class="block-details">
            <li v-for="(innerSelection, innerType) in parentSelection.selections"
                :key="innerType"
                class="block-item"
            >
              <span class="block-item-title">{{ innerType }}:</span>
              <span class="block-item-content">{{ innerSelection.join(', ') }}</span>
            </li>
          </ul>
        </div>
      </ul>
    </div>
  </CollapsePanel>
</template>

<script>
import { mapGetters } from 'vuex';

import AttributeValue from '@/components/AttributeValue.vue';
import CollapsePanel from '@/components/CollapsePanel.vue';
import * as dataCache from '@/store/cache/dataCache';

export default {
  name: 'ObjectInformation',
  components: {
    AttributeValue,
    CollapsePanel,
  },
  props: {
    mapObject: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      created_by: null,
    };
  },
  computed: {
    ...mapGetters({
      keyValues: 'settings/getKeyValues',
      mapObjectSelectionTypes: 'settings/getMapObjectSelectionTypes',
      mapObjectTypes: 'settings/getMapObjectTypes',
      mapObjectStatuses: 'settings/getMapObjectStatuses',
      users: 'settings/getUsers',
      user: 'user',
      network: 'settings/getNetworkModel',
    }),
    selectedType() {
      if (!this.mapObjectTypes) {
        return null;
      }
      if (!this.mapObject) {
        return null;
      }
      return this.mapObjectTypes[this.mapObject.map_object_type_id];
    },
    selectedStatus() {
      if (!this.mapObjectStatuses) {
        return null;
      }
      if (!this.mapObject) {
        return null;
      }
      return this.mapObjectStatuses[this.mapObject.map_object_status_id];
    },
    selectedUser() {
      if (!this.users) {
        return null;
      }
      if (!this.users) {
        return null;
      }
      return this.users[this.mapObject.created_by];
    },
    mapObjectLock() {
      if (!this.network || !this.network.id) {
        return null;
      }
      const lockItems = Object.values(this.keyValues)
        .filter(item => item.key.includes(`lock_mapobject_${this.network.id}`));
      if (lockItems.length > 0) {
        return lockItems[0];
      }
      return null;
    },
    length() {
      if (!this.mapObject.geoObject || !this.mapObject.geoObject.data.properties.length) {
        return null;
      }
      const length = parseFloat(this.mapObject.geoObject.data.properties.length);

      if (length > 1100) {
        return `${(length / 1000).toFixed(2)} km`;
      }
      return `${length.toFixed(0)} m`;
    },
    area() {
      if (!this.mapObject.geoObject || !this.mapObject.geoObject.data.properties.area) {
        return null;
      }
      const area = parseFloat(this.mapObject.geoObject.data.properties.area);

      if (area > 1100000) {
        return `${(area / 1000000).toFixed(0)} km<sup>2</sup>`;
      }
      return `${area.toFixed(0)} m<sup>2</sup>`;
    },
    selections() {
      const selections = dataCache.getSelectionsForMapObjectId(this.mapObject.id);
      const selectionByType = {};
      selections.forEach((mapObjectSelection) => {
        const typeName = this.mapObjectSelectionTypes[
          mapObjectSelection.map_object_selection_type_id
        ].name;
        if (!selectionByType[typeName]) {
          selectionByType[typeName] = [];
        }
        selectionByType[typeName].push(mapObjectSelection.name);
      });
      return selectionByType;
    },
    parentSelections() {
      const parents = dataCache.getParentsForMapObjectId(this.mapObject.id);
      if (!parents || parents.length === 0) {
        return {};
      }
      const selectionsByType = [];
      parents.forEach((parent) => {
        const selections = dataCache.getSelectionsForMapObjectId(parent.id);
        if (!selections || selections.length === 0) {
          return;
        }
        const parentSelections = {};
        selections.forEach((mapObjectSelection) => {
          const typeName = this.mapObjectSelectionTypes[
            mapObjectSelection.map_object_selection_type_id
          ].name;
          if (!parentSelections[typeName]) {
            parentSelections[typeName] = [];
          }
          parentSelections[typeName].push(mapObjectSelection.name);
        });
        selectionsByType.push({
          name: `${this.mapObjectTypes[parent.map_object_type_id].name} ${parent.name}`,
          selections: parentSelections,
        });
      });
      return selectionsByType;
    },
    hasSelections() {
      if (!this.selections) {
        return false;
      }
      if (!this.parentSelections) {
        return false;
      }
      return Object.keys(this.selections).length > 0 || this.parentSelections.length > 0;
    },
  },
};
</script>
<style scoped>
  .object-information-block {
    padding: 0 20px;
  }
  .object-information-block h3.block-header {
    text-transform: uppercase;
    font-style: normal;
    font-weight: 400;
    font-size: 1em;
    margin: 0 0 5px;
    padding: 0;
    color: #42464c;
  }
  .object-information-block ul.block-details {
    overflow: auto;
    zoom: 1;
    font-size: .85em;
    margin: 0 0 20px 0;
    padding: 0;
  }
  .object-information-block ul.block-details li.block-item {
    line-height: 1.7em;
    position: relative;
    clear: both;
    list-style: none;
  }
  .object-information-block .block-details .block-item .block-item-title {
    display: block;
    float: left;
    width: 40%;
  }
  .object-information-block .block-details .parent-selections {
    margin-left: 30px;
    font-size: 1.1em;
  }
</style>
